import React, { useEffect, useRef } from "react";
import "./lastsec.css";
import leftSinger from "../assets/ummkulthum4.png";
import songsPaper from "../assets/paper-songs.png";

import PlayBtn from "../components/playbtn";
import EngTitle from "../components/eng-title";
import ArTitle from "../components/ar-title";

const LastSec = () => {
  const sectionRef = useRef();

  useEffect(() => {
    const observer = new IntersectionObserver((entries) => {
      if (entries[0].isIntersecting) {
        sectionRef.current.classList.add("show");
      }
    }, { threshold: 0.25 });

    observer.observe(sectionRef.current);
  }, []);

  return (
    <section ref={sectionRef} className="songs-section">
      <img src={leftSinger} className="songs-left" alt="Umm Kulthum" />

      <div className="songs-header">
        <h2>Songs</h2>
        <p>
          Explore some of Umm Kulthum’s most famous and beloved songs
        </p>
      </div>

      <div className="songs-paper">
        <img src={songsPaper} className="paper-img" alt="Songs Paper" />

        <div className="songs-list">
          <div className="song-row row1">
            <div className="song-left-side">
              <PlayBtn />
              <EngTitle title="Anta Omri" />
            </div>
            <ArTitle title="انت عمري" />
          </div>

          <div className="song-row row2">
            <div className="song-left-side">
              <PlayBtn />
              <EngTitle title="Enta Al Hob" />
            </div>
            <ArTitle title="انت الحب" />
          </div>

          <div className="song-row row3">
            <div className="song-left-side">
              <PlayBtn />
              <EngTitle title="Amal hayati" />
            </div>
            <ArTitle title="امل حياتي" />
          </div>

          <div className="song-row row4">
            <div className="song-left-side">
              <PlayBtn />
              <EngTitle title="Alf Leila Wa Leila" />
            </div>
            <ArTitle title="الف ليله و ليله" />
          </div>
        </div>
      </div>
    </section>
  );
};

export default LastSec;